const getDateAtMidnight = (date: string | Date): Date => {
    return new Date(new Date(date).setUTCHours(0, 0, 0, 0));
};

export default getDateAtMidnight;
